// Uclean-Admin-Dashboard/src/mocks/promo/reactivationAudit/handlers.js

import { http, HttpResponse } from 'msw';
import { BASE } from '../_shared/base';
import { paginate } from '../_shared/pagination';
import auditFixture from './fixtures.json';

const ROOT = `${BASE}/promo-codes/reactivation-audit`;

export const reactivationAuditHandlers = [
  http.get(ROOT, ({ request }) => {
    const url = new URL(request.url);
    const campaignId = url.searchParams.get('campaign_id');
    const customerId = url.searchParams.get('customer_id');
    let rows = auditFixture;
    if (campaignId) rows = rows.filter((r) => r.campaign_id === campaignId);
    if (customerId) rows = rows.filter((r) => r.customer_id === customerId);
    return HttpResponse.json(paginate(rows, {
      page: url.searchParams.get('page'),
      perPage: url.searchParams.get('per_page') || 50,
    }));
  }),
];
